//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 功能模块定义
const functionalMod = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/accountingEngine/functionalMod.vue')),
    'functionalMod'
  );
// 单据定义
const billDefinition = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/accountingEngine/billDefinition.vue')),
    'billDefinition'
  );
// 单据定义详情
const billDefinitionDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/accountingEngine/billDefinitionDetail.vue')),
    'billDefinitionDetail'
  );
// 凭证模块定义
const voucher = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/accountingEngine/voucher/voucherMod.vue')),
    'voucher'
  );
// 凭证模块定义
const voucherDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/accountingEngine/voucher/voucherDetail.vue')),
    'voucherDetail'
  );

const accountingEngine = {
  path: '/accountingEngine',
  component: index,
  children: [
    {
      path: 'functionalMod',
      name: 'functionalMod',
      component: functionalMod,
      meta: {
        keepAlive: true,
        title: '功能模块定义',
      },
    },
    {
      path: 'billDefinition',
      name: 'billDefinition',
      component: billDefinition,
      meta: {
        keepAlive: true,
        title: '单据定义',
      },
    },
    {
      path: 'billDefinitionDetail',
      name: 'billDefinitionDetail',
      component: billDefinitionDetail,
      meta: {
        keepAlive: true,
        title: '单据定义详情',
      },
    },
    {
      path: 'voucher',
      name: 'voucher',
      component: voucher,
      meta: {
        keepAlive: true,
        title: '凭证模板定义',
      },
    },
    {
      path: 'voucherDetail',
      name: 'voucherDetail',
      component: voucherDetail,
      meta: {
        keepAlive: true,
        title: '凭证模板定义详情',
      },
    },
  ],
};
export default accountingEngine;
